var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{attrs:{"currentSwipedUser":_vm.currentSwipedUser,"notificationArray":_vm.notificationArray},on:{"navbaremit":function($event){_vm.notificationArray = []}}}),_c('v-main',[_c('router-view',{attrs:{"currentSwipedUser":_vm.currentSwipedUser}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }